import { Modal } from "../..";
import { Dispatch, SetStateAction, useState } from "react";
import { Button } from "../../Button";
import _ from "lodash";
import { Spinner } from "../../Loader";
import { FieldName } from "../Inputs";

export const UploadListModal = ({
  show,
  setShowExternal,
  setStrings,
}: {
  show: boolean;
  setShowExternal: Dispatch<SetStateAction<boolean>>;
  setStrings: (value: any) => void;
}) => {
  const [nameList, setNameList] = useState<string[]>([]);
  const [parsingText, setParsingText] = useState<boolean>(false);

  const onFileSelected = (file: File | null) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        setParsingText(true);
        try {
          const result = (e.target?.result || "").toString();
          const array = _.split(
            result.replaceAll('"', "").replaceAll(",", ""),
            "\n"
          );
          setNameList(array);
        } finally {
          setParsingText(false);
        }
      };
      reader.readAsText(file);
    }
  };

  return (
    <Modal setShowExternal={setShowExternal} showModal={show}>
      <Modal.Display
        useCloseBtn={false}
        tailwindWidth="w-auto"
        tailwindHeight="h-auto"
      >
        <Modal.Body>
          <div className="bg-white px-6 py-4 flex flex-col gap-4 justify-between rounded-md">
            <div className="font-bold text-xl">Upload text file of names</div>
            <div className="text-sm w-full">
              <p>Separate names with line breaks.</p>
              <p>All double quotes and commas in the file will be removed.</p>
              <p className="text-warningRed font-bold">
                WARNING: Uploading a new file will overwrite existing names
              </p>
            </div>
            <input
              type="file"
              onChange={(e) =>
                onFileSelected(e.target.files ? e.target.files[0] : null)
              }
              accept=".txt"
            />
            <div className="h-4 text-lightGray text-lg mb-2">
              {parsingText ? (
                <div className="flex gap-2 text-sm text-lightGray">
                  <Spinner /> Parsing file...
                </div>
              ) : nameList.length < 0 ? (
                <span>No names selected</span>
              ) : (
                <span>{nameList.length} names parsed</span>
              )}
            </div>
            <div className="flex gap-4 justify-center">
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  setShowExternal(false);
                  setNameList([]);
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  setShowExternal(false);
                  setStrings(nameList);
                }}
                disabled={nameList.length < 1 || parsingText}
              >
                Update
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal.Display>
    </Modal>
  );
};
